import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { Database } from 'lucide-react';

/**
 * Phase 15 — draggable entry for a real CRM field (see crmFieldRegistry.js).
 * Mirrors PaletteItem's drag mechanics exactly, but carries the full field
 * definition (not just a type) so FormBuilderPage's onDragEnd can build a
 * fully-configured component — correct input type, enum options, label —
 * in one drop instead of a blank field the user has to hand-configure.
 */
export default function CrmFieldPaletteItem({ field }) {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `crm-palette-${field.object}-${field.key}`,
    data: { source: 'crm-field', field },
  });

  return (
    <button
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      type="button"
      style={{ transform: CSS.Translate.toString(transform) }}
      className={`w-full flex items-center gap-2.5 px-3 py-2.5 rounded-[4px] border border-[#D8DDE6] bg-white hover:border-[#0176D3] hover:bg-[#F4F6F9] text-left transition-colors cursor-grab active:cursor-grabbing ${isDragging ? 'opacity-40' : ''}`}
    >
      <Database size={14} className="text-[#706E6B] shrink-0" />
      <span className="text-[12px] font-medium text-[#181818] truncate">{field.label}</span>
    </button>
  );
}
